import { createFileRoute } from "@tanstack/react-router";
import { ShopApproveScreen } from "../../screens/data/ShopApprove.tsx";

/** `/connect/<platform>?shop=…&redirect_uri=…&state=…&code_challenge=…`: where Adea's plugin in a web shop sends the person. */
export const Route = createFileRoute("/_app/connect/$platform")({
  component: ShopApproveScreen,
});
